import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useGetAttendantEarningPaymentHistory = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("agentearning/list?searchFilter=" + data.searchFilter + "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize);
    }, options);
};

export const useGetAttendantPaymentHistory = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("agentearning/agent-earning-payment-history?agentID=" + data.agentID);
    }, options);
};

export const useUpdateAgentEarning = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("agentearning/agent-earning-pay-proof/submit", data);
    }, options);
};